module.exports = __webpack_public_path__ + "static/media/slimpay-logo-gray.f4c3b799.svg";